import React from 'react';
import Lottie from 'react-lottie';

export const LoadingAnimation = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: require('../../../loadinganimation.json'),
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <Lottie options={defaultOptions} height={300} width={300} isStopped={false} isPaused={false} />
  );
};
